import { Link, LinkProps } from 'src/components';
import * as S from './styles';

export type BreadcrumbProps = {
  breadcrumb: { name: string; url: LinkProps['href'] };
  current: boolean;
};

export const Breadcrumb = ({ breadcrumb: { name, url }, current }: BreadcrumbProps) => {
  return (
    <S.BreadcrumbContainer aria-current={current ? 'page' : undefined}>
      <Link href={url} passHref legacyBehavior>
        <S.Breadcrumb data-testid="breadcrumbs-item">{name}</S.Breadcrumb>
      </Link>
    </S.BreadcrumbContainer>
  );
};
